export const limited1_50 = (value: string) => {
  return value.length < 1 || value.length > 50
}
export const validateAmount = (val: string) => {
  const num = parseFloat(val)
  return isNaN(num) || num < 0.01 || num > 50000
}
export function validatePositiveNumericInput(value: string): boolean {
  // 正则表达式：仅允许非负整数或非负小数
  const numericRegex = /^\d+(\.\d+)?$/
  return numericRegex.test(value)
}
